import { FC, forwardRef, useRef } from 'react';
import { IonDatetime } from '@ionic/react';
import { AllieDatetimeProps } from './Datetime.types';
import { ButtonsContainer, StyledCancelButton, StyledSelectButton } from './DateTime.styles';

export const AllieDatetime: FC<AllieDatetimeProps> = forwardRef(({
  onChange,
  isMobile = false,
  onMobileCloseModal,
  ...props
}, ref: React.Ref<HTMLIonDatetimeElement>) => {
  const dateTimeRef = useRef<null | HTMLIonDatetimeElement>(null);

  const cancel = () => {
    onMobileCloseModal?.();
  };
  const confirm = (e: any) => {
    const element = ref && typeof ref !== 'function' && 'current' in ref
      ? ref.current
      : dateTimeRef.current;
    element?.confirm?.();
    onMobileCloseModal?.();
  };

  return (
    <IonDatetime
      style={{ maxWidth: '100%' }}
      ref={ref || dateTimeRef}
      onIonChange={onChange}
      onIonCancel={cancel}
      {...props}
    >
      {isMobile && (
        <ButtonsContainer slot="buttons">
          <StyledSelectButton full onclick={confirm}>
            {props.doneText}
          </StyledSelectButton>
          <StyledCancelButton full onclick={cancel}>
            {props.cancelText}
          </StyledCancelButton>
        </ButtonsContainer>
      )}
    </IonDatetime>
  );
});
